module.exports = __webpack_public_path__ + "assets/social.1f568648632670679fbcd85bb55f56ee.svg";


//////////////////
// WEBPACK FOOTER
// ./img/social.svg
// module id = 422
// module chunks = 0